module.exports = __webpack_public_path__ + "fonts/DroidKufi-Regular.436938da.woff2";